import * as stylex from "@stylexjs/stylex";
import { Button, EmptyState } from "@softmax/design-system";
import { useEffect } from "react";
import { communityPageStyles as styles } from "./community-page.stylex";

export function CommunityPageError({
  error,
  retry,
}: {
  error: unknown;
  retry: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main id="main" {...stylex.props(styles.page)}>
      <div role="alert">
        <EmptyState title="Couldn’t load this page" titleLevel={1}>
          Something went wrong reaching Softmax. Try again in a moment.
        </EmptyState>
      </div>
      <Button onClick={retry}>Try again</Button>
    </main>
  );
}
